module.exports = __webpack_public_path__ + "static/img/bcg1.f599d14f.webp";